export const TIME_FORMAT = 'H:mm';
export const DATE_FORMAT = 'd/L/y';
export const TABLE_DATE_FORMAT = 'yyyy-LL-dd';
export const NOTIFICATION_DATE_FORMAT = 'dd MM y';
